var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpBigGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a1a1a1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5,0l5,6H0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBigGrey);
export default __webpack_public_path__ + "static/media/arrow-up-big-grey.1938d411bb92d52632709a7bec693e28.svg";
export { ForwardRef as ReactComponent };